module.exports = __webpack_public_path__ + "static/media/promo.f3565b5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/promo.png
// module id = 252
// module chunks = 0